<template>
  <div class="uni-max row m-0 calpage-d">
    <div class="col-lg-6 cd-padding">
      <div class="cal-results">
        <div class="p-4 uni-max-xs">
          <div class="cal-result-div">
            <div class="cal-subtitle">Loan Repayment</div>
            <div class="cal-redtitle mt-2">RM {{addComma(smonthPay)}}</div>
          </div>
          <div class="row mx-0 mt-3">
            <div class="pl-0 col-7">
              <div class="cal-subtitle">Interest</div>
            </div>
            <div class="pr-0 col-5">
              <div class="font-weight-bold">RM {{addComma(smonthInt)}}</div>
            </div>
          </div>
        </div>
        <div class="border-t p-4 uni-max-xs">
          <div class="cal-title">Total</div>
          <div class="row m-0">
            <div class="pl-0 col-7">
              <div class="mb-3">Total Principal</div>
              <div class="mb-3">Total Interest</div>
              <div>Total Payment</div>
            </div>
            <div class="pr-0 col-5">
              <div class="font-weight-bold mb-3">RM {{addComma(stotalPrin)}}</div>
              <div class="font-weight-bold mb-3">RM {{addComma(stotalInt)}}</div>
              <div class="font-weight-bold">RM {{addComma(stotalPay)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-6 cd-padding">
      <div class="cal-form-container">
        <div class="cal-label">Purchase Price</div> 
        <div class="filter-price-wrapper">
          <span class="filter-price-rm">RM</span>
          <input type='number' v-model="purcPrice" class="filter-price-range">
        </div>
        
        <div class="cal-label">Loan Amount (%)</div> 
        <div class="filter-price-wrapper">
          <input type='number' v-model="loanAm" class="filter-price-range" placeholder="E.g. 80  (of your loan amount)">
          <span class="filter-price-rm ml-auto">%</span>
        </div>

        <div class="cal-label">Loan Tenure</div> 
        <div class="filter-price-wrapper">
          <input type='number' v-model="loanTen" class="filter-price-range" placeholder="Number of years">
          <span class="filter-price-rm w-auto ml-auto">years</span>
        </div>

        <div class="cal-label">Interest Rate (%)</div> 
        <div class="filter-price-wrapper">
          <input type='number' v-model="intRate" class="filter-price-range">
          <span class="filter-price-rm ml-auto">%</span>
        </div>

        <div class="about-title mt-5">Optional (Monthly)</div>

        <div class="cal-label">MRTA</div> 
        <div class="filter-price-wrapper">
          <span class="filter-price-rm">RM</span>
          <input type='number' v-model="mrta" class="filter-price-range">
        </div>

        <button @click="calculate" class="cal-btn">
          <span v-if="isloaded">Calculate my Repayment</span>
          <div v-else class="spinner-border text-light" role="status" style="width: 1rem; height: 1rem;">
            <span class="sr-only">Loading...</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LoanCalculator',
    data: function () {
      return {
        // Loan Calculator
        purcPrice: null,
        loanAm: null,
        loanTen: null,
        intRate: null,
        mrta: 0,
        isloaded: true,

        // Results (update when press calculate)
        stotalPrin: '',
        smonthPay: '',
        smonthInt: '',
        stotalInt: '',
        stotalPay: '',
      }
    },
    mounted() {
      this.purcPrice = 500000
      this.loanAm = 90;
      this.loanTen = 30;
      this.intRate = 5;
      this.mrta = 0;
      
      this.stotalPrin = this.totalPrin;
      this.smonthPay = this.monthPay;
      this.smonthInt = this.monthInt;
      this.stotalInt = this.totalInt;
      this.stotalPay = this.totalPay;
    },
    computed: {
      totalPrin() {
        return parseFloat(this.purcPrice * this.loanAm / 100) + parseFloat(this.mrta);
      },
      monthPay() {
        let x = this.intRate / 1200;
        let w = 12 * this.loanTen;
        let y = Math.pow((1 + x), w);
        return Math.round((parseFloat(this.totalPrin) * x) * (y) / (y - 1));
      },
      monthInt() {
        let x = this.intRate / 1200;
        let w = 12 * this.loanTen;
        return Math.round(parseFloat(this.totalInt) / w);
      },
      totalInt() {
        return Math.round(parseFloat(this.totalPay) - parseFloat(this.totalPrin));
      },
      totalPay() {
        return Math.round(parseFloat(this.monthPay) * 12 * this.loanTen);
      },
    },
    methods: {
      addComma: function (num) {
        if (num != null) {
          var num_parts = num.toString().split(".");
          num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return num_parts.join(".");
        } else {
          return '';
        }
      },
      isEven: function (n) {
        var num = n;
        if (Math.floor(n) % 2 == 0) { // is even with decimal
          num = Math.round(n)
          if (num % 2 != 0) {
            num = num + 1
          }
        } else { // is odd with decimal
          num = Math.floor(n) + 1;
        }
        return num;
      },
      calculate: function() {
        this.isloaded = false;

        setTimeout(() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
          this.isloaded = true;

          // Update Results
          this.stotalPrin = this.totalPrin;
          this.smonthPay = this.monthPay;
          this.smonthInt = this.monthInt;
          this.stotalInt = this.totalInt;
          this.stotalPay = this.totalPay;
        }, 500);
      }
    },
  }
</script>